import React from 'react';
import autobind from 'autobind-decorator';
import Base from 'client/components/base';
import DelayedInput from 'client/components/common/delayed-input';
import Search from 'client/components/common/search';
import StringStore from 'client/stores/strings';

export default class SearchModule extends Base {
  constructor() {
    super();

    this.state = {
      query: null,
      isSearching: false,
    };
  }

  @autobind
  onUpdate(e) {
    this.setState({
      query: e.value,
    });
  }

  @autobind
  onSearchStart() {
    this.setState({
      isSearching: true,
    });
  }

  @autobind
  onSearchEnd() {
    this.setState({
      isSearching: false,
    });
  }

  render() {
    return (
      <section className={this.css({ searching: this.state.isSearching })}>
        <div className="content">
          <div className="search-field-wrapper">
            <DelayedInput
              placeholder={StringStore.get('common.searchPlaceholder')}
              className="search-field"
              onUpdate={this.onUpdate}
              type="text"
            />
            <div className="loader" />
          </div>
        </div>
        <Search
          query={this.state.query}
          fieldClassName="search-field"
          onSearchStart={this.onSearchStart}
          onSearchEnd={this.onSearchEnd}
        />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/cc-modules/search-module/search-module.es6